import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  CardMedia,
  Typography,
  Tooltip,
  ButtonBase,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { keyframes } from "@mui/system";

import { motion, AnimatePresence } from "framer-motion";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";

import fondo from "../image/aaa.png";
import trigoLand from "../image/tieraTrigo.png";
import maizLand from "../image/pasto.png";
import molino from "../image/Land_Electrica.png";
import aguaImg from "../image/Land_pozo.png";
import granja from "../image/Land_vacas.png";
import granja2 from "../image/land_gallinas.png";

import { Agua } from "./Modales/Agua";
import { TierraMaiz } from "./Modales/TierraMaiz";
import { Trigo } from "./Modales/Trigo";
import { useSelector } from "react-redux";
import { Arbol } from "./Modales/Arbol";
import { Wallet } from "./Modales/Wallet";
import { Energia } from "./Modales/Energia";
import { Vaca } from "./Modales/Vaca";
import { Gallinero } from "./Modales/Gallinero";
//import { Market } from "./market/Market";
import { TradesMarket } from "./market/TradesMarket";

import { Molino } from "./molino/Molino";
import { Alerta } from "./ux/Alert";
import { Profile } from "./Modales/Profile";
import { Ecosistema } from "./Modales/Ecosistema";
import { Torneos } from "./eventos/Torneos";
import { Objetos } from "./Modales/Ojbetos";

// ✅ NPC
import { FarmerNPC } from "../npc/FarmerNPC";

// ✅ VISIT FARMS MODAL
import CityFarmVisitFarms from "./CityFarmVisitFarms";

import { PacksMarket } from "./market/PacksMarket";

// ✅ NEW: POOL / STAKE (ajusta el path real)
import { Stake } from "./Modales/profile/Stake";


//✅ PET BIGDOGBONE
import PetOverlay from "./PetOverlay/PetOverlay";
import { rutas } from "../rutas/rutas";

dayjs.extend(utc);

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100%", sm: "80%" },
  maxHeight: "95vh",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

const arbol =
  "https://res.cloudinary.com/devuvyuij/image/upload/v1682520600/CITYFARMING/ARBOL/image_3_amwxov.png";

/* =========================
   ✅ IMÁGENES POR NIVEL (PLACEHOLDERS)
   - Repite la misma imagen para todos los niveles.
   - Luego tú reemplazas los links por los reales.
   ========================= */

// ✅ Helper: elige imagen según nivel (si se pasa, usa la última)
function pickByLevel(level, images = []) {
  const n = Number(level ?? 1);
  const idx = Math.max(0, Math.min(images.length - 1, n - 1));
  return images[idx] || images[0] || "";
}

// ✅ Helper: imagen de tierra según estado + nivel
function pickLandImage({
  land,
  emptyArr,
  workArr,
  readyArr,
  isReadyFn,
  isLockedFn,
  forceLocked = false,
  lockedImage = null,
}) {
  const lvl = land?.nivel ?? 1;

  // locked override
  const locked =
    forceLocked ||
    (typeof isLockedFn === "function" ? isLockedFn(land) : false);
  if (locked && lockedImage) return lockedImage;

  // empty (no time)
  if (!land?.tiempo || land?.tiempo === "") return pickByLevel(lvl, emptyArr);

  // ready vs working
  const ready = typeof isReadyFn === "function" ? isReadyFn(land) : false;
  return ready ? pickByLevel(lvl, readyArr) : pickByLevel(lvl, workArr);
}

// ✅ Ajusta cuantos niveles quieras (aquí pongo 10 por default)
const LVL_COUNT = 10;
const repeat = (img) => Array.from({ length: LVL_COUNT }, () => img);

// 🌳 Árbol (vacío / trabajando / listo)
const ARBOL_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285920/lvl1_q4eyov.png", // lvl1
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl2_docxz1.png", // lvl2
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl3_qmm43n.png", // lvl3
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285925/lvl4_bhqffb.png", // lvl4
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285928/lvl5_owxm6p.png", // lvl5
];
const ARBOL_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285920/lvl1_q4eyov.png", // lvl1
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl2_docxz1.png", // lvl2
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl3_qmm43n.png", // lvl3
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285925/lvl4_bhqffb.png", // lvl4
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285928/lvl5_owxm6p.png", // lvl5
];
const ARBOL_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285920/lvl1_q4eyov.png", // lvl1
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl2_docxz1.png", // lvl2
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285923/lvl3_qmm43n.png", // lvl3
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285925/lvl4_bhqffb.png", // lvl4
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767285928/lvl5_owxm6p.png", // lvl5
];

// 🌾 Trigo
const TRIGO_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767275202/tieraTrigo.cb46df694f72f63aabb4_g02e5k.png", // lvl1
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl2_hvk6rn_iqey5g.png", // lvl2
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl_3_gvzzie_d5f8vb.png", // lvl3
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276768/lvl_4_p871g9_eyg9lt.png", // lvl4
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276767/lvl5_lmykkk_bwynot.png", // lvl5
];

const TRIGO_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767275202/tieraTrigo.cb46df694f72f63aabb4_g02e5k.png", // lvl1
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl2_hvk6rn_iqey5g.png", // lvl2
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl_3_gvzzie_d5f8vb.png", // lvl3
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276768/lvl_4_p871g9_eyg9lt.png", // lvl4
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276767/lvl5_lmykkk_bwynot.png", // lvl5
];

const TRIGO_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767275202/tieraTrigo.cb46df694f72f63aabb4_g02e5k.png", // lvl1
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl2_hvk6rn_iqey5g.png", // lvl2
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276766/lvl_3_gvzzie_d5f8vb.png", // lvl3
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276768/lvl_4_p871g9_eyg9lt.png", // lvl4
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767276767/lvl5_lmykkk_bwynot.png", // lvl5
];

// 🌽 Maíz
const MAIZ_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767277907/pasto.b9b7aae7a28230fccbb6_pgkcfm.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278210/lvl2_rojyue.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl3_zioeyi.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl4_fhxhah.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278287/lvl5_c8ifrc.png",
];
const MAIZ_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767277907/pasto.b9b7aae7a28230fccbb6_pgkcfm.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278210/lvl2_rojyue.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl3_zioeyi.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl4_fhxhah.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278287/lvl5_c8ifrc.png",
];
const MAIZ_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767277907/pasto.b9b7aae7a28230fccbb6_pgkcfm.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278210/lvl2_rojyue.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl3_zioeyi.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278212/lvl4_fhxhah.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767278287/lvl5_c8ifrc.png",
];

// 🐄 Vacas
const VACA_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280654/lvl1_kpvrhn.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280655/lvl2_xbatel.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280669/lvl3_ngb7zk.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280670/lvl4_skdphg.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280671/lvl5_gmfkfr.png",
];
const VACA_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280654/lvl1_kpvrhn.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280655/lvl2_xbatel.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280669/lvl3_ngb7zk.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280670/lvl4_skdphg.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280671/lvl5_gmfkfr.png",
];
const VACA_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280654/lvl1_kpvrhn.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280655/lvl2_xbatel.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280669/lvl3_ngb7zk.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280670/lvl4_skdphg.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767280671/lvl5_gmfkfr.png",
];

// 🐔 Gallinas
const GALLINAS_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279773/lvl1_fzyo2i.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl2_tcqkuz.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl3_p93byw.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279776/lvl4_viwota.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279779/lvl5_ez5sdm.png",
];
const GALLINAS_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279773/lvl1_fzyo2i.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl2_tcqkuz.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl3_p93byw.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279776/lvl4_viwota.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279779/lvl5_ez5sdm.png",
];
const GALLINAS_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279773/lvl1_fzyo2i.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl2_tcqkuz.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279775/lvl3_p93byw.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279776/lvl4_viwota.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767279779/lvl5_ez5sdm.png",
];

// 💧 Agua
const AGUA_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287128/lvl1_mgtynd.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl2_rchvkc.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287131/lvl3_fzeegn.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl4_yvysld.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287130/lvl5_rlqhcf.png",
];
const AGUA_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287128/lvl1_mgtynd.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl2_rchvkc.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287131/lvl3_fzeegn.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl4_yvysld.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287130/lvl5_rlqhcf.png",
];
const AGUA_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287128/lvl1_mgtynd.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl2_rchvkc.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287131/lvl3_fzeegn.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287129/lvl4_yvysld.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767287130/lvl5_rlqhcf.png",
];

// ⚡ Energía
const ENERGIA_EMPTY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324324/lvl1_fnfhze.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324327/lvl2_yjkpyu.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324325/lvl3_e19aro.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324326/lvl4_rcf5ew.png",
  "https://res.cloudinary.com/dkm71aag8/image/upload/v1788703107/logos/enerigia_lv5_xmvtgx.png",
];
const ENERGIA_WORK = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324324/lvl1_fnfhze.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324327/lvl2_yjkpyu.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324325/lvl3_e19aro.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324326/lvl4_rcf5ew.png",
  "https://res.cloudinary.com/dkm71aag8/image/upload/v1788703107/logos/enerigia_lv5_xmvtgx.png",
];
const ENERGIA_READY = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324324/lvl1_fnfhze.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324327/lvl2_yjkpyu.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324325/lvl3_e19aro.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767324326/lvl4_rcf5ew.png",
  "https://res.cloudinary.com/dkm71aag8/image/upload/v1788703107/logos/enerigia_lv5_xmvtgx.png",
];

// 🏠 Home (entrada molino) por nivel
const HOME_LVL = [
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752471/LVL_1_hobgtm.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752471/LVL2_crp4nw.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752474/LVL3_r6c5dh.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752473/LVL4_ymzyk5.png",
  "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752473/LVL5_ppgq3x.png",
];

/* =========================
   ✅ RIGHT SIDE ICON BAR
   ========================= */
const pulse = keyframes`
  0%   { transform: scale(1); }
  50%  { transform: scale(1.08); }
  100% { transform: scale(1); }
`;


/* =========================
   ✅ HUD DE BENEFICIO DE MASCOTA
   - Consulta la misma mascota de Big Dog Bone.
   - ACTIVO: brilla, titila y muestra el porcentaje real del backend.
   - INACTIVO: aparece gris y apagado.
   - El frontend solo muestra datos; NO calcula ni envía beneficios.
   ========================= */
/*
 * IMPORTANTE:
 * El HUD de City Farm debe leer el beneficio desde el backend de City Farm,
 * porque esa ruta usa el mismo helper central `cityFarmPetBenefits.js`
 * utilizado por mision.js, recolectar.js y Molino.js.
 *
 * NO se debe usar /api/bdb/pet/me ni /api/bdb/pet/benefit para este HUD,
 * porque esas rutas calculan los beneficios propios de Big Dog Bone.
 */
const CITYFARM_PET_BENEFIT_URL =
  typeof rutas?.petBenefit === "string" && rutas.petBenefit.trim()
    ? rutas.petBenefit
    : "/api/pet-benefit/";

const PET_HUD_IMAGE =
  "https://res.cloudinary.com/dekoxefky/image/upload/v1780870756/dog_walk_1.png_xhd04p.png";

const petBenefitPulse = keyframes`
  0% {
    transform: scale(1);
    filter: brightness(1);
    box-shadow:
      0 0 5px rgba(124,255,156,0.35),
      0 0 12px rgba(124,255,156,0.18),
      inset 0 0 8px rgba(124,255,156,0.10);
  }
  50% {
    transform: scale(1.025);
    filter: brightness(1.18);
    box-shadow:
      0 0 10px rgba(124,255,156,0.95),
      0 0 24px rgba(124,255,156,0.62),
      inset 0 0 14px rgba(255,255,150,0.25);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
    box-shadow:
      0 0 5px rgba(124,255,156,0.35),
      0 0 12px rgba(124,255,156,0.18),
      inset 0 0 8px rgba(124,255,156,0.10);
  }
`;

const petBenefitShine = keyframes`
  0% { left: -70%; opacity: 0; }
  15% { opacity: 0.95; }
  65% { opacity: 0.95; }
  100% { left: 125%; opacity: 0; }
`;

const petDogBounce = keyframes`
  0%, 100% { transform: translateY(0) rotate(-1deg); }
  50% { transform: translateY(-3px) rotate(1deg); }
`;

function getCookieToken(name = "token") {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(^| )${name}=([^;]+)`)
  );
  return match ? decodeURIComponent(match[2]) : null;
}

function getPetHudToken() {
  if (typeof window === "undefined") return null;

  /*
   * La cookie representa el login actual de City Farm.
   * Se usa primero para evitar que un token viejo de storage cargue
   * la identidad o los beneficios de otro usuario.
   */
  return (
    getCookieToken("token") ||
    sessionStorage.getItem("token") ||
    localStorage.getItem("token")
  );
}

function firstFiniteNumber(...values) {
  for (const value of values) {
    if (value === null || typeof value === "undefined" || value === "") {
      continue;
    }
    const number = Number(value);
    if (Number.isFinite(number)) return number;
  }
  return 0;
}

function formatHudNumber(value, maxDecimals = 3) {
  const number = Number(value ?? 0);
  if (!Number.isFinite(number)) return "0";

  return number.toLocaleString(undefined, {
    maximumFractionDigits: maxDecimals,
  });
}

function normalizePetHudPayload(payload = {}) {
  /*
   * Respuesta esperada de GET /api/pet-benefit/:
   * {
   *   ok: true,
   *   user: "nombre",
   *   petBenefit: {
   *     active,
   *     reason,
   *     level,
   *     stage,
   *     cityFarm: {
   *       farmTimeReductionPercent,
   *       waterProductionBonusPercent,
   *       energyTimeReductionPercent,
   *       millTimeReductionPercent
   *     }
   *   }
   * }
   */
  const benefit =
    payload?.petBenefit ||
    payload?.cityFarmPetBenefit ||
    payload?.benefit ||
    payload?.data?.petBenefit ||
    payload?.data?.cityFarmPetBenefit ||
    payload?.data?.benefit ||
    (typeof payload?.active !== "undefined" ? payload : {});

  const cityFarmBenefit =
    benefit?.cityFarm && typeof benefit.cityFarm === "object"
      ? benefit.cityFarm
      : {};

  return {
    loading: false,
    loaded: true,
    error: false,
    active: Boolean(benefit?.active),
    reason:
      benefit?.reason ||
      (benefit?.active ? "ACTIVE" : "NO_ACTIVE_PET_BENEFIT"),
    level: Math.max(
      1,
      Math.floor(firstFiniteNumber(benefit?.level, 1))
    ),
    stage: benefit?.stage || "puppy",
    name:
      payload?.user ||
      payload?.data?.user ||
      benefit?.owner ||
      "My Puppy",
    status: benefit?.active ? "alive" : benefit?.reason || "unknown",

    /*
     * Estos cuatro valores salen exclusivamente de
     * cityFarmPetBenefits.js. No se recalculan en el frontend.
     */
    farmPercent: firstFiniteNumber(
      cityFarmBenefit?.farmTimeReductionPercent,
      cityFarmBenefit?.productionBonusPercent
    ),
    waterPercent: firstFiniteNumber(
      cityFarmBenefit?.waterProductionBonusPercent
    ),
    energyPercent: firstFiniteNumber(
      cityFarmBenefit?.energyTimeReductionPercent
    ),
    millPercent: firstFiniteNumber(
      cityFarmBenefit?.millTimeReductionPercent
    ),

    cityFarm: cityFarmBenefit,
    bdb: {},
    pet: {},
  };
}

function HudCounter({ icon, label, value, accent = "#ffffff", onClick }) {
  return (
    <motion.div
      whileHover={{ scale: 1.035, y: -1 }}
      whileTap={onClick ? { scale: 0.98 } : undefined}
      style={{ flex: "0 0 auto", width: "100%" }}
    >
      <Box
        onClick={onClick}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyDown={(event) => {
          if (!onClick) return;
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onClick();
          }
        }}
        sx={{
          height: 42,
          width: "100%",
          minWidth: { xs: 76, sm: 72 },
          px: 0.7,
          py: 0.35,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 1.4,
          background:
            "linear-gradient(180deg, rgba(10,28,15,0.92), rgba(4,17,9,0.88))",
          border: "1px solid rgba(210,255,210,0.14)",
          boxShadow:
            "inset 0 0 10px rgba(255,255,255,0.035), 0 1px 0 rgba(0,0,0,0.28)",
          color: "white",
          userSelect: "none",
          cursor: onClick ? "pointer" : "default",
          textAlign: "center",
          backdropFilter: "blur(2px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.45,
            width: "100%",
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: 14,
              lineHeight: 1,
              filter: "drop-shadow(0 1px 0 #000)",
            }}
          >
            {icon}
          </Typography>
          <Typography
            sx={{
              color: accent,
              fontSize: 12.5,
              lineHeight: 1.05,
              fontWeight: 950,
              whiteSpace: "nowrap",
              textShadow: "0 1px 0 #000",
            }}
          >
            {formatHudNumber(value)}
          </Typography>
        </Box>

        <Typography
          sx={{
            mt: 0.25,
            color: "rgba(255,255,255,0.88)",
            fontSize: 8.3,
            lineHeight: 1,
            fontWeight: 900,
            letterSpacing: 0.45,
            whiteSpace: "nowrap",
            width: "100%",
            textAlign: "center",
            textShadow: "0 1px 0 #000",
          }}
        >
          {label}
        </Typography>
      </Box>
    </motion.div>
  );
}

function PetBenefitHud({ petHud }) {
  const isLoading = Boolean(petHud?.loading);
  const hasError = Boolean(petHud?.error);
  const active = Boolean(petHud?.active) && !hasError;


  const title = isLoading
    ? "CHECKING PET..."
    : hasError
    ? "PET DATA OFFLINE"
    : active
    ? "PET BOOST ON"
    : "PET BOOST OFF";

  const subtitle = isLoading
    ? "LOADING"
    : hasError
    ? "NO CONNECTION"
    : active
    ? `LVL ${petHud?.level || 1} • F-${formatHudNumber(
        petHud?.farmPercent,
        1
      )}% W+${formatHudNumber(
        petHud?.waterPercent,
        1
      )}% E-${formatHudNumber(
        petHud?.energyPercent,
        1
      )}% M-${formatHudNumber(petHud?.millPercent, 1)}%`
    : "INACTIVE • NEEDS CARE";

  const tooltipContent = (
    <Box sx={{ p: 0.4, minWidth: 205 }}>
      <Typography sx={{ fontWeight: 950, fontSize: 13, mb: 0.5 }}>
        🐶 {petHud?.name || "My Puppy"}
      </Typography>
      <Typography sx={{ fontSize: 11.5 }}>
        Status: {active ? "Benefit active" : hasError ? "Data unavailable" : "Benefit inactive"}
      </Typography>
      <Typography sx={{ fontSize: 11.5 }}>
        Farm production time: -{formatHudNumber(petHud?.farmPercent, 1)}%
      </Typography>
      <Typography sx={{ fontSize: 11.5 }}>
        Water collected: +{formatHudNumber(petHud?.waterPercent, 1)}%
      </Typography>
      <Typography sx={{ fontSize: 11.5 }}>
        Energy cycle time: -{formatHudNumber(petHud?.energyPercent, 1)}%
      </Typography>
      <Typography sx={{ fontSize: 11.5 }}>
        Mill processing time: -{formatHudNumber(petHud?.millPercent, 1)}%
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="bottom">
      <Box
        sx={{
          position: "relative",
          isolation: "isolate",
          flex: "0 0 auto",
          height: 44,
          width: "100%",
          minWidth: { xs: 215, sm: 235 },
          px: 0.9,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.85,
          overflow: "hidden",
          borderRadius: 1.5,
          border: active
            ? "2px solid rgba(124,255,156,0.95)"
            : "1px solid rgba(255,255,255,0.16)",
          background: active
            ? "linear-gradient(180deg, rgba(20,91,43,0.98), rgba(2,35,16,0.98))"
            : "linear-gradient(180deg, rgba(35,35,35,0.97), rgba(8,8,8,0.97))",
          animation: active
            ? `${petBenefitPulse} 1.25s ease-in-out infinite`
            : "none",
          boxShadow: active
            ? undefined
            : "inset 0 0 10px rgba(255,255,255,0.025)",
          "@media (prefers-reduced-motion: reduce)": {
            animation: "none",
          },
          "&::after": active
            ? {
                content: '\"\"',
                position: "absolute",
                zIndex: 0,
                top: "-45%",
                left: "-70%",
                width: "42%",
                height: "190%",
                transform: "skewX(-20deg)",
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,180,0.10), rgba(255,255,190,0.82), rgba(255,255,180,0.10), transparent)",
                animation: `${petBenefitShine} 2s linear infinite`,
                pointerEvents: "none",
              }
            : undefined,
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            width: 34,
            height: 34,
            flex: "0 0 34px",
            borderRadius: "50%",
            overflow: "hidden",
            background: active
              ? "radial-gradient(circle, rgba(255,255,170,0.90), rgba(64,180,80,0.30) 55%, rgba(0,0,0,0.75) 100%)"
              : "radial-gradient(circle, rgba(120,120,120,0.32), rgba(0,0,0,0.85) 75%)",
            border: active
              ? "1px solid rgba(255,255,160,0.95)"
              : "1px solid rgba(255,255,255,0.12)",
            boxShadow: active ? "0 0 12px rgba(255,255,130,0.9)" : "none",
          }}
        >
          <Box
            component="img"
            src={PET_HUD_IMAGE}
            alt="Pet benefit"
            draggable={false}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              userSelect: "none",
              filter: active
                ? "brightness(1.12) saturate(1.18) drop-shadow(0 1px 0 rgba(0,0,0,0.8))"
                : "grayscale(1) brightness(0.42) opacity(0.62)",
              animation: active
                ? `${petDogBounce} 1.1s ease-in-out infinite`
                : "none",
              "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
              },
            }}
          />
        </Box>

        <Box sx={{ position: "relative", zIndex: 2, minWidth: 0, textAlign: "center", flex: 1 }}>
          <Typography
            sx={{
              color: active ? "#8CFFA8" : "rgba(255,255,255,0.48)",
              fontSize: { xs: 10.5, sm: 11.5 },
              lineHeight: 1.05,
              fontWeight: 950,
              letterSpacing: 0.45,
              whiteSpace: "nowrap",
              textShadow: active
                ? "0 0 8px rgba(124,255,156,0.9), 0 1px 0 #000"
                : "0 1px 0 #000",
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              mt: 0.35,
              color: active ? "#FFF27A" : "rgba(255,255,255,0.30)",
              fontSize: { xs: 7.2, sm: 7.8 },
              lineHeight: 1,
              fontWeight: 900,
              letterSpacing: 0.05,
              whiteSpace: "nowrap",
              textShadow: "0 1px 0 #000",
            }}
          >
            {subtitle}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: 4,
            right: 5,
            zIndex: 3,
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: active
              ? "#7CFF9C"
              : hasError
              ? "#ff6b6b"
              : "rgba(255,255,255,0.20)",
            boxShadow: active ? "0 0 9px #7CFF9C" : "none",
          }}
        />
      </Box>
    </Tooltip>
  );
}

/* =========================
   ✅ EFECTO ESPECIAL VISIT FARMS
   - Luz dorada recorriendo el botón
   - Pulso verde suave
   - Badge NEW
   ========================= */
const visitFarmLightMove = keyframes`
  0% {
    left: -80%;
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  55% {
    opacity: 1;
  }
  100% {
    left: 135%;
    opacity: 0;
  }
`;

const visitFarmPulse = keyframes`
  0% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.035);
    filter: brightness(1.18);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
`;

const visitFarmsButtonSx = {
  position: "relative",
  overflow: "hidden !important",
  isolation: "isolate",
  animation: `${visitFarmPulse} 3.8s ease-in-out infinite`,
  boxShadow:
    "0 0 8px rgba(90,255,120,0.55), 0 0 16px rgba(90,255,120,0.35), inset 0 0 8px rgba(255,230,120,0.25)",
  "& p": {
    position: "relative",
    zIndex: 5,
  },
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-35%",
    left: "-80%",
    width: "50%",
    height: "170%",
    background:
      "linear-gradient(90deg, transparent, rgba(255,255,180,0.18), rgba(255,255,120,0.9), rgba(255,255,180,0.18), transparent)",
    transform: "skewX(-18deg)",
    animation: `${visitFarmLightMove} 4.6s linear infinite`,
    pointerEvents: "none",
    zIndex: 4,
  },
  "&::after": {
    content: '"NEW"',
    position: "absolute",
    top: "-8px",
    right: "-6px",
    padding: "2px 6px",
    borderRadius: "8px",
    background: "#4cff63",
    color: "#102b12",
    fontSize: "9px",
    fontWeight: 900,
    lineHeight: 1.2,
    textShadow: "none",
    boxShadow: "0 0 8px rgba(76,255,99,0.9)",
    pointerEvents: "none",
    zIndex: 6,
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
    "&::before": {
      animation: "none",
      opacity: 0,
    },
  },
};

const getMenuButtonSx = (active = false) => ({
  minHeight: 48,
  minWidth: { xs: 118, md: 122 },
  px: 1.15,
  m: 0.15,
  transform: active ? "translateY(-2px)" : "none",
  filter: active ? "brightness(1.13)" : "none",
  boxShadow: active
    ? "0 0 0 2px rgba(124,255,156,0.70), 0 0 14px rgba(124,255,156,0.38)"
    : "0 3px 0 rgba(0,0,0,0.28)",
  transition: "transform 150ms ease, filter 150ms ease, box-shadow 150ms ease",
  "&:hover": {
    transform: "translateY(-2px)",
    filter: "brightness(1.10)",
  },
  "& p": {
    margin: 0,
    lineHeight: 1,
    letterSpacing: 0.15,
    whiteSpace: "nowrap",
  },
});


function VerticalLogosRight({ items = [], sx: extraSx = {}, children }) {
  const goToLogo = (item) => {
    if (!item) return;
    if (item.type === "internal" && item.to) {
      window.location.href = item.to;
      return;
    }
    if (item.type === "external" && item.href) {
      window.open(item.href, "_blank", "noopener,noreferrer");
      return;
    }
  };

  return (
    <Box
      sx={{
        position: "absolute",
        top: { xs: 88, sm: 110 },
        right: { xs: 12, sm: 16 },
        display: "flex",
        flexDirection: "column",
        gap: 1.2,
        zIndex: 20000,
        p: 1,
        borderRadius: 3,
        bgcolor: "rgba(255,255,255,0.08)",
        backdropFilter: "blur(6px)",
        boxShadow: 3,
        ...extraSx,
      }}
    >
      {children}

      {items.map((g, idx) => (
        <Tooltip key={g.name} title={g.name} arrow placement="left">
          <ButtonBase
            onClick={() => goToLogo(g)}
            sx={{
              borderRadius: 2,
              p: 0.5,
              transition: "transform 120ms ease, opacity 120ms ease",
              "&:hover": { transform: "translateX(-2px)", opacity: 0.9 },
            }}
            aria-label={`Go to ${g.name}`}
          >
            <CardMedia
              component="img"
              image={g.logo}
              alt={g.name}
              loading="lazy"
              sx={{
                width: { xs: 42, sm: 54 },
                height: "auto",
                display: "block",
                borderRadius: 1.5,
                willChange: "transform",
                transformOrigin: "center",
                animation: `${pulse} 1.6s ease-in-out infinite`,
                animationDelay: `${idx * 0.12}s`,
                "@media (prefers-reduced-motion: reduce)": { animation: "none" },
              }}
            />
          </ButtonBase>
        </Tooltip>
      ))}
    </Box>
  );
}

// ✅ (kept) Info button (commented where you had it)
function CityFarmInfoButton() {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          cursor: "pointer",
          bgcolor: "rgba(0,0,0,0.6)",
          borderRadius: 2,
          p: 0.5,
          mb: 1,
          display: "flex",
          justifyContent: "center",
          transition: "transform 120ms ease, opacity 120ms ease",
          "&:hover": { transform: "translateY(-1px)", opacity: 0.95 },
        }}
        title="Info"
      >
        <CardMedia
          component="img"
          image="https://res.cloudinary.com/devuvyuij/image/upload/v1680463586/CITYFARMING/gallina_yww1kq.png"
          alt="Info"
          sx={{ width: 42, height: 42, display: "block" }}
          loading="lazy"
        />
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "rgba(20,20,20,0.98)",
            color: "white",
            borderRadius: 3,
            p: 3,
            width: 360,
            textAlign: "center",
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" sx={{ mb: 1.2, fontWeight: 900 }}>
            🌾 City Farm
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Quick panel: links / announcements / metrics.
          </Typography>

          <Box
            sx={{ mt: 1.5, display: "flex", gap: 1, justifyContent: "center" }}
          >
            <Button
              variant="contained"
              onClick={() =>
                window.open(
                  "https://cityfarmgame.com/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              Open Game
            </Button>
            <Button
              variant="outlined"
              onClick={() => setOpen(false)}
              sx={{ color: "white", borderColor: "rgba(255,255,255,0.35)" }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

/** READY particles */
function ReadyParticles({ show }) {
  if (!show) return null;
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 6,
        pointerEvents: "none",
      }}
    >
      {[0, 1, 2, 3, 4].map((i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            left: `${18 + i * 14}%`,
            bottom: "26%",
            width: 6,
            height: 6,
            background: "rgba(120,255,160,0.95)",
            boxShadow: "0 0 0 2px rgba(0,0,0,0.35)",
            borderRadius: "2px",
            animation: `readyFloat 1.6s ease-in-out ${i * 0.12}s infinite`,
            opacity: 0.95,
          }}
        />
      ))}

      <style>
        {`
          @keyframes readyFloat {
            0%   { transform: translateY(0) scale(0.9); opacity: 0.0; }
            15%  { opacity: 0.9; }
            60%  { opacity: 0.9; }
            100% { transform: translateY(-28px) scale(1.15); opacity: 0.0; }
          }
        `}
      </style>
    </Box>
  );
}

/** Hover sparkles */
function HoverSparkles({ show }) {
  if (!show) return null;
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 6,
        pointerEvents: "none",
      }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            left: `${35 + i * 12}%`,
            top: `${30 + i * 10}%`,
            width: 4,
            height: 4,
            background: "rgba(255,255,255,0.9)",
            boxShadow: "0 0 0 2px rgba(0,0,0,0.25)",
            borderRadius: "1px",
            animation: `spark 0.9s ease-in-out ${i * 0.1}s infinite`,
            opacity: 0.9,
          }}
        />
      ))}
      <style>
        {`
          @keyframes spark {
            0%   { transform: scale(0.8); opacity: 0.0; }
            30%  { opacity: 1.0; }
            70%  { opacity: 1.0; }
            100% { transform: scale(1.25); opacity: 0.0; }
          }
        `}
      </style>
    </Box>
  );
}

/** Tile */
function Tile({
  image,
  onClick,
  lvl,
  locked,
  ready,
  w = { xs: "100%", md: "70%" },
  float = true,
  badgeText,
  working,
  progress,
  highlight,

  // Reserva la franja de progreso en todas las tierras habilitadas.
  // HOME puede desactivarla con showProgress={false}.
  showProgress = true,

  // ✅ NEW (keeps everything else intact)
  broken = false,
}) {
  const [hover, setHover] = useState(false);
  const showWorking = !!working && !ready && !locked;

  const progClamped =
    typeof progress === "number" ? Math.max(0, Math.min(1, progress)) : null;

  // Barra estable: READY = 100%; sin trabajo/temporizador = 0%.
  // No altera la lógica del terreno, solo su representación visual.
  const progressForDisplay = ready
    ? 1
    : typeof progClamped === "number"
    ? progClamped
    : 0;
  const showProgressBar = showProgress && !locked;

  const progressFill =
    progressForDisplay >= 0.8
      ? "linear-gradient(90deg, #38d66b, #a8ff8c)"
      : progressForDisplay >= 0.45
      ? "linear-gradient(90deg, #d9b23f, #ffe27a)"
      : "linear-gradient(90deg, #d7772d, #ffb45f)";

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        minWidth: 0,
        minHeight: 0,
        boxSizing: "border-box",
        // Espacio fijo para que la barra no choque con el sprite ni se corte.
        pb: showProgressBar ? { xs: "24px", md: "28px" } : 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transform: highlight ? "translateZ(0)" : "none",
      }}
    >
      {/* shadow */}
      <motion.div
        style={{
          position: "absolute",
          bottom: "18%",
          width: "62%",
          height: 16,
          borderRadius: "999px",
          background: "rgba(0,0,0,0.35)",
          filter: "blur(8px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
        animate={{
          opacity: locked ? 0.22 : ready ? [0.25, 0.55, 0.25] : 0.35,
          scaleX: locked ? 0.95 : ready ? [0.95, 1.1, 0.95] : 1.0,
          scaleY: locked ? 0.95 : ready ? [0.95, 1.06, 0.95] : 1.0,
        }}
        transition={{
          duration: ready ? 1.1 : 0.35,
          repeat: ready ? Infinity : 0,
          ease: "easeInOut",
        }}
      />

      {/* highlight */}
      {highlight && !locked && (
        <motion.div
          style={{
            position: "absolute",
            inset: 8,
            borderRadius: 10,
            zIndex: 1,
            pointerEvents: "none",
            boxShadow:
              "0 0 0 2px rgba(120,255,160,0.55), 0 0 20px rgba(120,255,160,0.35)",
          }}
          animate={{ opacity: [0.35, 0.95, 0.35] }}
          transition={{ duration: 0.9, repeat: Infinity, ease: "easeInOut" }}
        />
      )}

      {/* ready glow */}
      {ready && !locked && (
        <Box
          sx={{
            position: "absolute",
            inset: 10,
            borderRadius: 2,
            zIndex: 1,
            filter: "blur(14px)",
            opacity: 0.95,
            background:
              "radial-gradient(circle at 50% 50%, rgba(80,255,120,0.60), rgba(0,0,0,0))",
            pointerEvents: "none",
          }}
        />
      )}

      {/* working glow */}
      {showWorking && !locked && (
        <motion.div
          style={{
            position: "absolute",
            inset: 14,
            borderRadius: 10,
            zIndex: 1,
            pointerEvents: "none",
            boxShadow:
              "inset 0 0 18px rgba(255,210,100,0.08), 0 0 10px rgba(255,210,100,0.08)",
          }}
          animate={{ opacity: [0.25, 0.55, 0.25] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        />
      )}

      {/* ✅ Broken red glow + crack overlay */}
      {broken && !locked && (
        <>
          <motion.div
            style={{
              position: "absolute",
              inset: 10,
              borderRadius: 10,
              zIndex: 2,
              pointerEvents: "none",
              boxShadow:
                "0 0 0 2px rgba(255,70,70,0.40), 0 0 26px rgba(255,70,70,0.20)",
            }}
            animate={{ opacity: [0.25, 0.9, 0.25] }}
            transition={{ duration: 0.9, repeat: Infinity, ease: "easeInOut" }}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 10,
              zIndex: 2,
              pointerEvents: "none",
              background:
                "repeating-linear-gradient(180deg, rgba(255,255,255,0.06) 0px, rgba(255,255,255,0.00) 3px, rgba(255,255,255,0.00) 7px)",
              mixBlendMode: "overlay",
              opacity: 0.9,
              borderRadius: 10,
            }}
          />
        </>
      )}

      <ReadyParticles show={ready && !locked} />
      <HoverSparkles show={hover && !locked} />

      {/* LVL */}
      {typeof lvl !== "undefined" && (
        <Typography
          sx={{
            position: "absolute",
            right: 10,
            top: 8,
            zIndex: 8,
            color: "white",
            textShadow: "0 2px 0 rgba(0,0,0,0.9)",
            fontSize: { xs: 10.5, md: 12 },
            fontWeight: 950,
            lineHeight: 1,
            px: 0.55,
            py: 0.3,
            borderRadius: 0.8,
            background: "rgba(0,0,0,0.38)",
            border: "1px solid rgba(255,255,255,0.08)",
            pointerEvents: "none",
          }}
        >
          {`LVL-${lvl}`}
        </Typography>
      )}

      {/* badge */}
      {(badgeText || ready || locked || showWorking || broken) && (
        <Box
          sx={{
            position: "absolute",
            left: 10,
            top: 8,
            zIndex: 8,
            px: 0.9,
            py: 0.3,
            borderRadius: 1,
            fontSize: { xs: 9.5, md: 11 },
            fontWeight: 900,
            letterSpacing: 0.6,
            color: broken
              ? "#FF6B6B"
              : locked
              ? "#CFCFCF"
              : ready
              ? "#7CFF9C"
              : "#FFD27C",
            background: "rgba(0,0,0,0.70)",
            border: "1px solid rgba(255,255,255,0.15)",
            textTransform: "uppercase",
            userSelect: "none",
            pointerEvents: "none",
          }}
        >
          {badgeText
            ? badgeText
            : broken
            ? "BROKEN"
            : locked
            ? "LOCKED"
            : ready
            ? "READY"
            : showWorking
            ? "WORKING"
            : ""}
        </Box>
      )}

      {/* progress mini: visible en toda tierra habilitada */}
      {showProgressBar && (
        <Box
          sx={{
            position: "absolute",
            left: { xs: "12%", md: "16%" },
            right: { xs: "12%", md: "16%" },
            bottom: { xs: 3, md: 5 },
            zIndex: 8,
            height: 18,
            borderRadius: 1,
            overflow: "hidden",
            background: "rgba(0,0,0,0.68)",
            border: "1px solid rgba(255,255,255,0.13)",
            boxShadow: "0 2px 5px rgba(0,0,0,0.28)",
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 3,
              borderRadius: 0.7,
              background: "rgba(255,255,255,0.09)",
              overflow: "hidden",
            }}
          >
            <>
              <motion.div
                style={{
                  height: "100%",
                  borderRadius: 4,
                  background: progressFill,
                }}
                animate={{ width: `${progressForDisplay * 100}%` }}
                transition={{ duration: 0.4, ease: "easeOut" }}
              />
              {progressForDisplay > 0 && progressForDisplay < 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    width: "32%",
                    opacity: 0.3,
                    background:
                      "linear-gradient(90deg, transparent, rgba(255,255,255,0.88), transparent)",
                    animation: "shimmer 1.6s linear infinite",
                  }}
                />
              )}
            </>
          </Box>

          <Typography
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: 9.5,
              lineHeight: 1,
              fontWeight: 950,
              textShadow: "0 1px 2px rgba(0,0,0,0.95)",
            }}
          >
            {`${(progressForDisplay * 100).toFixed(1)}%`}
          </Typography>

          <style>
            {`
              @keyframes indet {
                0% { left: -40%; opacity: 0.7; }
                50% { opacity: 1; }
                100% { left: 110%; opacity: 0.7; }
              }
              @keyframes shimmer {
                0% { left: -40%; }
                100% { left: 120%; }
              }
            `}
          </style>
        </Box>
      )}

      <motion.div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 3,
        }}
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{
          opacity: 1,
          scale: 1,
          y: float ? [0, -3, 0] : 0,
          rotate: locked ? [0, -0.5, 0.5, 0] : 0,
        }}
        transition={{
          opacity: { duration: 0.25 },
          scale: { duration: 0.25 },
          y: float
            ? { duration: 2.6, repeat: Infinity, ease: "easeInOut" }
            : undefined,
          rotate: locked
            ? { duration: 0.6, repeat: Infinity, repeatDelay: 2.4 }
            : undefined,
        }}
        whileHover={{
          scale: 1.05,
          filter: locked ? "grayscale(100%) brightness(0.75)" : "brightness(1.06)",
        }}
        whileTap={{ scale: 0.98 }}
      >
        <CardMedia
          onClick={onClick}
          className="rpgui-cursor-grab-open"
          component="img"
          image={image}
          sx={{
            width: w,
            maxHeight: { xs: "78%", md: "82%" },
            objectFit: "contain",
            filter: locked
              ? "grayscale(100%) brightness(0.75)"
              : broken
              ? "grayscale(80%) contrast(1.05) brightness(0.85)"
              : "none",
            transition: "filter .2s ease, transform .2s ease",
            userSelect: "none",
          }}
          draggable={false}
        />
      </motion.div>
    </Box>
  );
}

export const Prueba = ({ onOpenCityFarms }) => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [pagina, setPagina] = useState(0);
  const [selector, setSelector] = useState({});

  // ✅ NPC reward alert
  const [npcOpen, setNpcOpen] = useState(false);
  const [npcMsg, setNpcMsg] = useState("");
  const [npcErr, setNpcErr] = useState(false);

  const [highlightReady, setHighlightReady] = useState(false);
  const [tick, setTick] = useState(0);

  // ✅ Estado visual del beneficio real de la mascota.
  const [petHud, setPetHud] = useState({
    loading: true,
    loaded: false,
    error: false,
    active: false,
    level: 1,
    name: "My Puppy",
    farmPercent: 0,
    waterPercent: 0,
    energyPercent: 0,
    millPercent: 0,
    cityFarm: {},
    bdb: {},
    pet: {},
  });

  const { informacion } = useSelector((state) => state.userSlice);

  const idValidos = [10, 11, 5, 9, 12, 15, 16];

  // ✅ NUEVO: ID del POOL/STAKE (no es tierra)
  const POOL_PAGE_ID = 17;

  /* =========================================================
     ✅ MILL BROKEN STATUS (no extra API call, uses stored data if exists)
     ========================================================= */
  const millState = useMemo(() => {
    const m =
      informacion?.molino ||
      informacion?.mill ||
      informacion?.tierras?.molino ||
      informacion?.tierras?.energia ||
      null;

    const broken =
      Boolean(m?.roto) ||
      Boolean(m?.broken) ||
      Boolean(m?.isBroken) ||
      Boolean(informacion?.molinoRoto) ||
      false;

    const dur = Number(
      m?.durabilidad ?? m?.durability ?? informacion?.molinoDurabilidad ?? 100
    );

    const repairCost = Number(
      m?.repairCostCF ?? m?.repairCost ?? informacion?.molinoRepairCostCF ?? 0
    );

    return {
      broken,
      dur: Number.isFinite(dur) ? dur : 100,
      repairCost: Number.isFinite(repairCost) ? repairCost : 0,
    };
  }, [informacion]);

  const handleOpen = (id, item) => {
    // ✅ POOL no es tierra: siempre se abre
    if (id === POOL_PAGE_ID) {
      setPagina(POOL_PAGE_ID);
      setSelector({});
      setOpen(true);
      return;
    }

    if (!item?.habilitado && !idValidos.includes(id)) {
      setOpen2(true);
      return;
    }

    if (id === 10 && millState.broken) {
      setNpcErr(true);
      setNpcMsg("⚠️ The mill is broken. Repair it to unlock access.");
      setNpcOpen(true);

      setPagina(10);
      setSelector(item || {});
      setOpen(true);
      return;
    }

    setPagina(id);
    setSelector(item);
    setOpen(true);
  };

  useEffect(() => {
    if (pagina > 0) {
      const tierras = { ...informacion?.tierras };
      let tierra = {};
      for (const key in tierras) {
        const element = tierras[key];
        if (element?.id === selector?.id) {
          tierra = tierras[key];
        }
      }
      setSelector(tierra);
    }
  }, [informacion]);

  useEffect(() => {
    setOpen(true);
    setPagina(13);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, []);

  /* =========================================================
     ✅ CARGA DEL BENEFICIO REAL DE CITY FARM
     - Consulta únicamente GET /api/pet-benefit/.
     - Esa ruta usa cityFarmPetBenefits.js, igual que la lógica de producción.
     - Nunca toma los porcentajes de /api/bdb/pet/me.
     - Se actualiza cada 30 segundos y después de cuidar la mascota.
     ========================================================= */
  useEffect(() => {
    let mounted = true;

    const loadPetHud = async ({ silent = false } = {}) => {
      if (!silent && mounted) {
        setPetHud((prev) => ({
          ...prev,
          loading: true,
          error: false,
        }));
      }

      const token = getPetHudToken();

      try {
        const response = await fetch(CITYFARM_PET_BENEFIT_URL, {
          method: "GET",
          headers: token
            ? {
                token,
                Authorization: `Bearer ${token}`,
              }
            : {},
          credentials: "include",
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          const requestError = new Error(
            data?.error ||
              data?.message ||
              `PET BENEFIT HTTP ${response.status}`
          );
          requestError.status = response.status;
          throw requestError;
        }

        if (!mounted) return;

        const normalized = normalizePetHudPayload(data);

        console.log("[CITY FARM PET HUD] beneficio central cargado", {
          endpoint: CITYFARM_PET_BENEFIT_URL,
          user: data?.user,
          active: normalized.active,
          reason: normalized.reason,
          level: normalized.level,
          cityFarm: normalized.cityFarm,
        });

        setPetHud(normalized);
      } catch (error) {
        if (!mounted) return;

        console.warn(
          "[CITY FARM PET HUD] No se pudo cargar /api/pet-benefit/:",
          {
            endpoint: CITYFARM_PET_BENEFIT_URL,
            status: error?.status,
            message: error?.message,
          }
        );

        setPetHud((prev) => ({
          ...prev,
          loading: false,
          loaded: false,
          error: true,
          active: false,
        }));
      }
    };

    /*
     * No se aceptan porcentajes enviados por PetOverlay porque ese componente
     * consulta Big Dog Bone. El evento solo ordena volver a consultar el
     * endpoint central de City Farm.
     */
    const handlePetSync = () => {
      loadPetHud({ silent: true });
    };

    loadPetHud();

    const interval = setInterval(() => {
      loadPetHud({ silent: true });
    }, 30000);

    window.addEventListener("actualizar-saldos", handlePetSync);
    window.addEventListener("pet-benefit-updated", handlePetSync);
    window.addEventListener("pet-updated", handlePetSync);
    window.addEventListener(
      "cityfarm-pet-benefit-refresh",
      handlePetSync
    );

    return () => {
      mounted = false;
      clearInterval(interval);
      window.removeEventListener("actualizar-saldos", handlePetSync);
      window.removeEventListener("pet-benefit-updated", handlePetSync);
      window.removeEventListener("pet-updated", handlePetSync);
      window.removeEventListener(
        "cityfarm-pet-benefit-refresh",
        handlePetSync
      );
    };
  }, []);

  // helpers
  const isReady = (t) =>
    t?.tiempo && t?.tiempo !== "" && dayjs().utc().diff(t.tiempo, "second") > 0;

  const isLocked = (t) => !t?.habilitado;

  const isWorking = (t) => {
    if (!t?.habilitado) return false;
    if (!t?.tiempo || t.tiempo === "") return false;
    return !isReady(t);
  };

  // ✅ progress based on time + duration
  const getProgress = (t) => {
    if (!t?.tiempo || t.tiempo === "") return null;

    const rawDur =
      t?.duracionSeg ?? t?.durationSec ?? t?.duracion ?? t?.duration ?? null;
    if (rawDur == null) return null;

    const durNum = Number(rawDur);
    if (!Number.isFinite(durNum) || durNum <= 0) return null;

    const totalSeconds = durNum <= 96 ? durNum * 3600 : durNum;

    const now = dayjs().utc();
    const end = dayjs(t.tiempo).utc();

    const remaining = Math.max(0, end.diff(now, "second"));
    const prog = 1 - remaining / totalSeconds;

    return Math.max(0, Math.min(1, prog));
  };

  const readyCount = useMemo(() => {
    const tierras = informacion?.tierras || {};
    let c = 0;
    Object.keys(tierras).forEach((k) => {
      const t = tierras[k];
      if (t && t.tiempo && t.tiempo !== "" && isReady(t) && t.habilitado) c += 1;
    });
    return c;
  }, [informacion, tick]);

  // ✅ balances from inventory
  const getInvQtyLike = (keywords) => {
    const inv = informacion?.inventario || [];
    const keys = (keywords || []).map((k) => String(k).toLowerCase());
    const found = inv.find((x) => {
      const item = String(x?.item || "").toLowerCase();
      return keys.some((k) => item.includes(k));
    });
    const n = Number(found?.cantidad ?? 0);
    return Number.isFinite(n) ? n : 0;
  };

  const energiaHUD = getInvQtyLike(["energia", "energy", "power"]);
  const aguaHUD = getInvQtyLike(["agua", "water"]);
  const croquetasHUD = getInvQtyLike([
    "croquette",
    "croquettes",
    "croqueta",
    "comida",
    "food",
  ]);

  // ✅ Más saldos visibles. Se aceptan varios nombres para no romper versiones viejas.
  const cfHUD = firstFiniteNumber(
    informacion?.cf_cf,
    informacion?.cf,
    informacion?.dinero,
    informacion?.balanceCF,
    informacion?.saldoCF
  );

  const huesoHUD = firstFiniteNumber(
    informacion?.cf_hueso,
    informacion?.hueso,
    informacion?.dineroReal,
    informacion?.saldoHueso,
    petHud?.bdb?.dineroReal
  );

  const vipHuesoHUD = firstFiniteNumber(
    informacion?.cf_viphueso,
    informacion?.viphueso,
    informacion?.vipHueso,
    informacion?.saldoVipHueso
  );

  const hiveHUD = firstFiniteNumber(
    informacion?.cf_hive,
    informacion?.hive,
    informacion?.saldoHive,
    informacion?.swapHive
  );

  useEffect(() => {
    if (!highlightReady) return;
    const t = setTimeout(() => setHighlightReady(false), 4000);
    return () => clearTimeout(t);
  }, [highlightReady]);

  // ✅ NPC handler (English)
  const handleNpcReward = (reward) => {
    if (!reward) return;

    const item = reward?.item || reward?.name || "Reward";
    const qty = Number(reward?.qty ?? 1);

    setNpcErr(false);
    setNpcMsg(`🎁 You received ${qty} ${item}!`);
    setNpcOpen(true);
  };

  // parallax background
  const bgX = useMemo(() => (tick % 20) - 10, [tick]);

  // ✅ Right panels
  const gameLogos = [
    {
      name: "Big Dog Bone Web",
      logo: "https://www.bigdogbonegame.com/static/media/logo.5acc4af4e6491040e775.png",
      type: "external",
      href: "https://www.bigdogbonegame.com/game",
    },
    {
      name: "Discord",
      logo: "https://res.cloudinary.com/dkm71aag8/image/upload/v1755052358/logos/logo_nova_hv5mrd.png",
      type: "external",
      href: "https://discord.gg/ShA6MKRHz9",
    },
    {
      name: "Docs / Gitbook",
      logo: "https://res.cloudinary.com/dkm71aag8/image/upload/v1755052363/logos/mundoairdrops_s6mwyo.png",
      type: "external",
      href: "https://mundo-virtual.gitbook.io/mundo-bot-discord/",
    },
  ];

  const appsLogos = [
    {
      name: "HiveNFTs",
      logo: "https://res.cloudinary.com/dkm71aag8/image/upload/v1755319758/hivenfts-logo_sawbud.png",
      type: "external",
      href: "https://hivenfts.com/",
    },
    {
      name: "Buy/Sell HIVE",
      logo: "https://res.cloudinary.com/dkm71aag8/image/upload/v1755113326/7._hueso_1_astveu.png",
      type: "external",
      href: "https://tribaldex.com/swap",
    },
    {
      name: "Buy/Sell VIPHUESO",
      logo: "https://res.cloudinary.com/dkm71aag8/image/upload/v1755113343/8._viph_bn9r8g.webp",
      type: "external",
      href: "https://tribaldex.com/swap?from=SWAP.HIVE&to=VIPHUESO",
    },
  ];

  // ✅ LAND SHORTCUTS
  const arbol1 = informacion?.tierras?.arbol;
  const arbol2 = informacion?.tierras?.arbol2;
  const arbol3 = informacion?.tierras?.arbol3;

  const trigo1 = informacion?.tierras?.trigo;
  const trigo2 = informacion?.tierras?.trigo2;

  const maiz1 = informacion?.tierras?.maiz;
  const maiz2 = informacion?.tierras?.maiz2;

  const energia = informacion?.tierras?.energia;
  const vacas = informacion?.tierras?.granja2;
  const gallinas = informacion?.tierras?.granja1;
  const agua = informacion?.tierras?.agua;

  return (
    <Box
      className={`rpgui-container framed `}
      sx={{
        width: { xs: "calc(100vw - 10px)", sm: "calc(100vw - 16px)" },
        height: { xs: "calc(100vh - 10px)", sm: "calc(100vh - 16px)" },
        maxWidth: "1820px",
        maxHeight: "980px",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "hidden",
        flexDirection: "column",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "#5a565d",
      }}
    >
      {/* Volver al Ecosistema sin cerrar la sesión */}
      <Tooltip title="Volver al Ecosistema" arrow placement="left">
        <Box
          component="button"
          type="button"
          aria-label="Volver al Ecosistema"
          onClick={() => {
            window.location.assign(
              "https://www.bigdogbonegame.com/ecosystem"
            );
          }}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 10001,
            width: 44,
            height: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border: "2px solid #ff9800",
            borderTop: 0,
            borderRight: 0,
            borderRadius: "0 0 0 10px",
            background: "rgba(0,0,0,0.92)",
            color: "#ffffff",
            fontFamily: "inherit",
            fontSize: "1.35rem",
            fontWeight: 900,
            lineHeight: 1,
            p: 0,
            boxShadow: "0 4px 12px rgba(0,0,0,0.45)",
            transition:
              "background-color 160ms ease, color 160ms ease, transform 160ms ease",
            "&:hover": {
              background: "#ff9800",
              color: "#111111",
              transform: "scale(1.05)",
            },
            "&:focus-visible": {
              outline: "3px solid rgba(255,255,255,0.9)",
              outlineOffset: "2px",
            },
          }}
        >
          X
        </Box>
      </Tooltip>

      {/* ÁREA INTERNA DEL CAMPO: SOLO HUD + TIERRAS */}
      <Box
        className={`rpgui-container framed`}
        sx={{
          position: "absolute",
          top: { xs: 22, sm: 28 },
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "82%", md: "80%", lg: "79%" },
          height: { xs: "70%", sm: "72%", md: "77%" },
          minHeight: 520,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          zIndex: 2,
          backgroundImage: `url(${fondo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          boxShadow:
            "0 12px 26px rgba(0,0,0,0.26), inset 0 0 0 1px rgba(255,255,255,0.04)",
        }}
      >
      {/* HUD COMPLETO: SALDOS + BENEFICIO DE MASCOTA */}
      <Box
        sx={{
          position: "absolute",
          top: 5,
          left: 6,
          right: 6,
          zIndex: 9000,
          display: { xs: "flex", md: "grid" },
          gridTemplateColumns:
            "repeat(8, minmax(72px, 1fr)) minmax(195px, 1.65fr)",
          alignItems: "center",
          gap: 0.45,
          overflowX: "auto",
          overflowY: "hidden",
          px: 0.45,
          py: 0.35,
          borderRadius: 1.5,
          background:
            "linear-gradient(180deg, rgba(31,139,49,0.58), rgba(13,87,29,0.46))",
          border: "1px solid rgba(214,255,214,0.14)",
          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -10px 18px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.20)",
          backdropFilter: "blur(2.5px)",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          WebkitOverflowScrolling: "touch",
        }}
      >
        <HudCounter
          icon="⚡"
          label="ENERGY"
          value={energiaHUD}
          accent="#FFF27A"
        />

        <HudCounter
          icon="💧"
          label="WATER"
          value={aguaHUD}
          accent="#7FD7FF"
        />

        <HudCounter
          icon="🦴"
          label="CROQUETTES"
          value={croquetasHUD}
          accent="#FFD39A"
        />

        <HudCounter icon="🌾" label="CF" value={cfHUD} accent="#9CFF90" />

        <HudCounter
          icon="🦴"
          label="HUESO"
          value={huesoHUD}
          accent="#FFD27C"
        />

        <HudCounter
          icon="⭐"
          label="VIPHUESO"
          value={vipHuesoHUD}
          accent="#E8B7FF"
        />

        <HudCounter
          icon="◆"
          label="HIVE"
          value={hiveHUD}
          accent="#FF8E8E"
        />

        <HudCounter
          icon="✅"
          label="READY"
          value={readyCount}
          accent="#7CFF9C"
          onClick={() => setHighlightReady(true)}
        />

        <PetBenefitHud petHud={petHud} />
      </Box>

      {/* MAP */}
      <motion.div
        style={{ width: "100%", height: "100%" }}
        animate={{ x: bgX * 0.15 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundImage: `url(${fondo})`,
            backgroundSize: "cover",
            backgroundPosition: `${50 + bgX * 0.4}% 50%`,
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gridTemplateRows: "repeat(3, minmax(0, 1fr))",
            position: "relative",
            px: { xs: 0.8, md: 1.4 },
            pt: { xs: "56px", md: "58px" },
            // Colchón inferior para que la tercera fila conserve sus barras completas.
            pb: { xs: "6px", md: "10px" },
            boxSizing: "border-box",
            gap: { xs: 0.35, md: 0.8 },
          }}
        >
          {/* ✅ NPC */}
          <FarmerNPC onReward={handleNpcReward} />

          {/* ✅ Modal externo de VISIT FARMS.
              No muestra botón propio; se abre desde el botón inferior VISIT FARMS. */}
          <CityFarmVisitFarms npcMode={false} showAccessButton={false} />

          {/* HOUSE (entry to MILL in your modal mapping: pagina === 10) */}
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Tile
              image={pickByLevel(informacion?.molinoNivel ?? 1, HOME_LVL)}
              onClick={() => handleOpen(10)}
              w={{ xs: "80%", md: "72%" }}
              float={true}
              badgeText={millState.broken ? "MILL BROKEN" : "HOME"}
              broken={millState.broken}
              locked={false}
              ready={false}
              working={false}
              highlight={false}
              showProgress={false}
            />
          </Box>

          {/* TREE 1 */}
          <Tile
            lvl={arbol1?.nivel}
            locked={isLocked(arbol1)}
            ready={isReady(arbol1)}
            working={isWorking(arbol1)}
            progress={getProgress(arbol1)}
            highlight={highlightReady && isReady(arbol1)}
            image={pickLandImage({
              land: arbol1,
              emptyArr: ARBOL_EMPTY,
              workArr: ARBOL_WORK,
              readyArr: ARBOL_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(4, arbol1)}
            w={{ xs: "76%", md: "52%" }}
          />

          {/* TREE 2 */}
          <Tile
            lvl={arbol2?.nivel}
            locked={isLocked(arbol2)}
            ready={isReady(arbol2)}
            working={isWorking(arbol2)}
            progress={getProgress(arbol2)}
            highlight={highlightReady && isReady(arbol2)}
            image={pickLandImage({
              land: arbol2,
              emptyArr: ARBOL_EMPTY,
              workArr: ARBOL_WORK,
              readyArr: ARBOL_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(4, arbol2)}
            w={{ xs: "76%", md: "52%" }}
          />

          {/* TREE 3 */}
          <Tile
            lvl={arbol3?.nivel}
            locked={isLocked(arbol3)}
            ready={isReady(arbol3)}
            working={isWorking(arbol3)}
            progress={getProgress(arbol3)}
            highlight={highlightReady && isReady(arbol3)}
            image={pickLandImage({
              land: arbol3,
              emptyArr: ARBOL_EMPTY,
              workArr: ARBOL_WORK,
              readyArr: ARBOL_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(4, arbol3)}
            w={{ xs: "76%", md: "52%" }}
          />

          {/* WHEAT 1 */}
          <Tile
            lvl={trigo1?.nivel}
            locked={isLocked(trigo1)}
            ready={isReady(trigo1)}
            working={isWorking(trigo1)}
            progress={getProgress(trigo1)}
            highlight={highlightReady && isReady(trigo1)}
            image={pickLandImage({
              land: trigo1,
              emptyArr: TRIGO_EMPTY,
              workArr: TRIGO_WORK,
              readyArr: TRIGO_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(3, trigo1)}
            w={{ xs: "78%", md: "56%" }}
          />

          {/* WHEAT 2 */}
          <Tile
            lvl={trigo2?.nivel}
            locked={isLocked(trigo2)}
            ready={isReady(trigo2)}
            working={isWorking(trigo2)}
            progress={getProgress(trigo2)}
            highlight={highlightReady && isReady(trigo2)}
            image={pickLandImage({
              land: trigo2,
              emptyArr: TRIGO_EMPTY,
              workArr: TRIGO_WORK,
              readyArr: TRIGO_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(3, trigo2)}
            w={{ xs: "78%", md: "56%" }}
          />

          {/* CORN 1 */}
          <Tile
            lvl={maiz1?.nivel}
            locked={isLocked(maiz1)}
            ready={isReady(maiz1)}
            working={isWorking(maiz1)}
            progress={getProgress(maiz1)}
            highlight={highlightReady && isReady(maiz1)}
            image={pickLandImage({
              land: maiz1,
              emptyArr: MAIZ_EMPTY,
              workArr: MAIZ_WORK,
              readyArr: MAIZ_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(2, maiz1)}
            w={{ xs: "78%", md: "56%" }}
          />

          {/* CORN 2 */}
          <Tile
            lvl={maiz2?.nivel}
            locked={isLocked(maiz2)}
            ready={isReady(maiz2)}
            working={isWorking(maiz2)}
            progress={getProgress(maiz2)}
            highlight={highlightReady && isReady(maiz2)}
            image={pickLandImage({
              land: maiz2,
              emptyArr: MAIZ_EMPTY,
              workArr: MAIZ_WORK,
              readyArr: MAIZ_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(2, maiz2)}
            w={{ xs: "78%", md: "56%" }}
          />

          {/* POWER */}
          <Tile
            lvl={energia?.nivel}
            locked={isLocked(energia)}
            ready={false}
            working={false}
            progress={null}
            highlight={false}
            image={pickLandImage({
              land: energia,
              emptyArr: ENERGIA_EMPTY,
              workArr: ENERGIA_WORK,
              readyArr: ENERGIA_READY,
              isReadyFn: () => false,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(6, energia)}
            w={{ xs: "80%", md: "58%" }}
            badgeText={"POWER"}
          />

          {/* COWS */}
          <Tile
            lvl={vacas?.nivel}
            locked={isLocked(vacas)}
            ready={isReady(vacas)}
            working={isWorking(vacas)}
            progress={getProgress(vacas)}
            highlight={highlightReady && isReady(vacas)}
            image={pickLandImage({
              land: vacas,
              emptyArr: VACA_EMPTY,
              workArr: VACA_WORK,
              readyArr: VACA_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(7, vacas)}
            w={{ xs: "80%", md: "58%" }}
          />

          {/* CHICKENS */}
          <Tile
            lvl={gallinas?.nivel}
            locked={isLocked(gallinas)}
            ready={isReady(gallinas)}
            working={isWorking(gallinas)}
            progress={getProgress(gallinas)}
            highlight={highlightReady && isReady(gallinas)}
            image={pickLandImage({
              land: gallinas,
              emptyArr: GALLINAS_EMPTY,
              workArr: GALLINAS_WORK,
              readyArr: GALLINAS_READY,
              isReadyFn: isReady,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(8, gallinas)}
            w={{ xs: "80%", md: "58%" }}
          />

          {/* WATER */}
          <Tile
            lvl={agua?.nivel}
            locked={isLocked(agua)}
            ready={false}
            working={false}
            progress={null}
            highlight={false}
            image={pickLandImage({
              land: agua,
              emptyArr: AGUA_EMPTY,
              workArr: AGUA_WORK,
              readyArr: AGUA_READY,
              isReadyFn: () => false,
              isLockedFn: isLocked,
            })}
            onClick={() => handleOpen(1, agua)}
            w={{ xs: "80%", md: "58%" }}
            badgeText={"WATER"}
          />
        </Box>
      </motion.div>
      </Box>

      {/* BUTTONS */}
      <Box
        className={`rpgui-container framed`}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bottom: { xs: 18, sm: 24 },
          left: "50%",
          transform: "translateX(-50%)",
          position: "absolute",
          flexDirection: { md: "row" },
          gap: 0.2,
          px: 0.8,
          py: 0.55,
          background: "rgba(43,38,45,0.90)",
          boxShadow: "0 8px 18px rgba(0,0,0,0.28)",
          zIndex: 3,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 0.1 }}>
          <Button
            onClick={() => {
              window.dispatchEvent(new Event("open-city-farms-panel"));
            }}
            className="rpgui-button"
            sx={[getMenuButtonSx(false), visitFarmsButtonSx]}
          >
            <p>VISIT FARMS</p>
          </Button>
          <Button onClick={() => handleOpen(9)} className="rpgui-button" sx={getMenuButtonSx(open && pagina === 9)}>
            <p>TRADE</p>
          </Button>

          <Button onClick={() => handleOpen(16)} className="rpgui-button" sx={getMenuButtonSx(open && pagina === 16)}>
            <p>PACKS</p>
          </Button>
        </Box>

        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 0.1 }}>
          <Button onClick={() => handleOpen(11)} className="rpgui-button" sx={getMenuButtonSx(open && pagina === 11)}>
            <p>PROFILE</p>
          </Button>

          {/* ✅ NUEVO BOTÓN POOL */}
          <Button onClick={() => handleOpen(17)} className="rpgui-button" sx={getMenuButtonSx(open && pagina === 17)}>
            <p>POOL</p>
          </Button>

          <Button onClick={() => handleOpen(5)} className="rpgui-button" sx={getMenuButtonSx(open && pagina === 5)}>
            <p>INVENTORY</p>
          </Button>
          <Button onClick={() => handleOpen(15)} className="rpgui-button" sx={getMenuButtonSx(open && pagina === 15)}>
            <p>OBJECTS</p>
          </Button>
        </Box>
      </Box>

      {/* MODAL */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="rpgui-content"
      >
        <AnimatePresence>
          {open && (
            <Box
              className="rpgui-container framed"
              sx={{
                ...style,
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
              }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.97, y: 10 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.98, y: 10 }}
                transition={{ duration: 0.18 }}
              >
                {pagina === 1 && (
                  <Agua handleClose={() => setOpen(false)} selector={selector} />
                )}
                {pagina === 2 && (
                  <TierraMaiz selector={selector} handleClose={() => setOpen(false)} />
                )}
                {pagina === 3 && (
                  <Trigo selector={selector} handleClose={() => setOpen(false)} />
                )}
                {pagina === 4 && (
                  <Arbol handleClose={() => setOpen(false)} selector={selector} />
                )}
                {pagina === 5 && <Wallet handleClose={() => setOpen(false)} />}
                {pagina === 6 && (
                  <Energia handleClose={() => setOpen(false)} selector={selector} />
                )}
                {pagina === 7 && (
                  <Vaca handleClose={() => setOpen(false)} selector={selector} />
                )}
                {pagina === 8 && (
                  <Gallinero handleClose={() => setOpen(false)} selector={selector} />
                )}
                {pagina === 9 && <TradesMarket handleClose4={() => setOpen(false)} />}
                {pagina === 16 && <PacksMarket handleClose4={() => setOpen(false)} />}

                {/* ✅ Molino already contains the broken gate + repair UI */}
                {pagina === 10 && <Molino handleClose4={() => setOpen(false)} />}

                {pagina === 11 && <Profile handleClose={() => setOpen(false)} />}
                {pagina === 12 && <Ecosistema handleClose={() => setOpen(false)} />}

                {/* ✅ NUEVO: Pool / Stake separado (NO dentro de Profile) */}
                {pagina === 17 && <Stake />}

                {pagina === 13 && (
  <Box
    sx={{
      minHeight: "320px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 3,
      p: 4,
      textAlign: "center",
      background: "rgba(0,0,0,0.65)",
      borderRadius: 2,
    }}
  >
    <Box
      onClick={() => setOpen(false)}
      sx={{
        position: "absolute",
        right: 10,
        top: 10,
        zIndex: 10000000000001,
        color: "white",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: "20px",
      }}
    >
      X
    </Box>

    <Typography
      variant="h4"
      sx={{
        color: "#fff",
        fontWeight: 900,
        textShadow: "2px 2px 4px rgba(0,0,0,0.8)",
      }}
    >
      
    </Typography>

    <Button
      onClick={() =>
        window.open(
          "https://tribaldex.com/swap?from=SWAP.HIVE&to=HUESO",
          "_blank",
          "noopener,noreferrer"
        )
      }
      sx={{
        minWidth: 300,
        py: 1.8,
        fontWeight: 900,
        fontSize: "16px",
        color: "#fff",
        background: "linear-gradient(180deg, #8b5a2b, #5a3818)",
        border: "2px solid #d4af37",
        "&:hover": {
          background: "linear-gradient(180deg, #9c6a35, #6a431d)",
        },
      }}
    >
      BUY OR SELL HUESO
    </Button>

    <Button
      onClick={() =>
        window.open(
          "https://tribaldex.com/swap?from=SWAP.HIVE&to=VIPHUESO",
          "_blank",
          "noopener,noreferrer"
        )
      }
      sx={{
        minWidth: 300,
        py: 1.8,
        fontWeight: 900,
        fontSize: "16px",
        color: "#fff",
        background: "linear-gradient(180deg, #4b2e83, #2a174d)",
        border: "2px solid #c084fc",
        "&:hover": {
          background: "linear-gradient(180deg, #5b38a0, #341d61)",
        },
      }}
    >
      BUY OR SELL VIPHUESO
    </Button>
  </Box>
)}

                {pagina === 14 && (
                  <Box sx={{ width: "100%", height: "100%" }}>
                    <Box
                      onClick={() => setOpen(false)}
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        zIndex: 10000000000001,
                        color: "white",
                        cursor: "pointer",
                      }}
                    >
                      X
                    </Box>
                    <Torneos />
                  </Box>
                )}

                {pagina === 15 && <Objetos handleClose={() => setOpen(false)} />}
              </motion.div>
            </Box>
          )}
        </AnimatePresence>
      </Modal>

      {/* ALERTS */}
      <Alerta
        mensaje={"You need to buy the land"}
        open={open2}
        handleClose={() => setOpen2(false)}
        error={true}
      />

      <Alerta
        mensaje={npcMsg}
        open={npcOpen}
        handleClose={() => setNpcOpen(false)}
        error={npcErr}
      />

      {/* RIGHT PANELS */}
      <VerticalLogosRight items={gameLogos}>
        {/*
          <CityFarmInfoButton />
        */}
      </VerticalLogosRight>

      <VerticalLogosRight
        items={appsLogos}
        sx={{ top: "auto", bottom: { xs: 32, sm: 40 }, right: { xs: 12, sm: 16 } }}
      />

      <PetOverlay />
      
    </Box>
  );
};
